/* First Hijab Guide - share module (link sharing).
   Adds a Share control to each infographic image and comparison table. Sharing
   uses the Web Share API to share a deep link to that section (the Bubble Girl
   branding travels via the page's social/OG image when the link unfurls). Falls
   back to copying the link. No external libraries, collects no personal data. */
(function () {
  'use strict';

  var CAN_SHARE = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function copyLink(url, setStatus) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(
        function () { setStatus('Link copied'); },
        function () { window.prompt('Copy this link', url); }
      );
    } else {
      window.prompt('Copy this link', url);
    }
  }

  function nearestAnchorId(node) {
    var h = node;
    while (h) {
      var prev = h.previousElementSibling;
      while (prev) {
        if (/^H[1-4]$/.test(prev.tagName) && prev.id) return prev.id;
        var inner = prev.querySelector && prev.querySelector('[id]');
        if (inner && inner.id) return inner.id;
        prev = prev.previousElementSibling;
      }
      h = h.parentElement;
      if (h && h.classList && h.classList.contains('fhg')) break;
    }
    return '';
  }

  function makeBar(title, anchorId) {
    var bar = el('div', 'fhg-share');
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Share ' + title);
    var label = el('span', 'fhg-share__label', 'Share');
    var status = el('span', 'fhg-share__status');
    status.setAttribute('aria-live', 'polite');

    function urlFor() {
      return location.origin + location.pathname + (anchorId ? '#' + anchorId : '');
    }
    function setStatus(t) {
      status.textContent = t;
      if (t) { setTimeout(function () { status.textContent = ''; }, 2500); }
    }

    bar.appendChild(label);

    if (CAN_SHARE) {
      var shareBtn = el('button', 'fhg-share__btn', ICON + '<span>Share</span>');
      shareBtn.type = 'button';
      shareBtn.addEventListener('click', function () {
        navigator.share({
          title: 'Bubble Girl - ' + title,
          text: title + ' - from the Bubble Girl first hijab guide.',
          url: urlFor()
        }).catch(function () { /* user cancelled or unsupported */ });
      });
      bar.appendChild(shareBtn);
    }

    var copyBtn = el('button', 'fhg-share__btn', '<span>Copy link</span>');
    copyBtn.type = 'button';
    copyBtn.addEventListener('click', function () { copyLink(urlFor(), setStatus); });
    bar.appendChild(copyBtn);

    bar.appendChild(status);
    return bar;
  }

  function init() {
    if (!document.querySelector('.fhg')) return;

    [].slice.call(document.querySelectorAll('.fhg-table-scroll')).forEach(function (wrap) {
      var table = wrap.querySelector('table');
      if (!table) return;
      var cap = table.querySelector('caption');
      var title = cap ? cap.textContent.trim() : 'Hijab guide table';
      wrap.parentNode.insertBefore(makeBar(title, nearestAnchorId(wrap)), wrap.nextSibling);
    });

    [].slice.call(document.querySelectorAll('figure.fhg-figure')).forEach(function (fig) {
      if (fig.closest('.fhg-steps')) return;
      var img = fig.querySelector('img');
      if (!img) return;
      var cap = fig.querySelector('figcaption');
      var title = cap ? cap.textContent.trim() : (img.getAttribute('alt') || 'Bubble Girl hijab guide');
      fig.parentNode.insertBefore(makeBar(title, nearestAnchorId(fig)), fig.nextSibling);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
